import { Address, PublicClient } from 'viem';

import { getDelegateStakingPoolContract } from 'modules/api/contracts/getDelegateStakingPoolContract';

export async function getPoolOwner(
  client: PublicClient,
  poolAddress: Address,
): Promise<Address> {
  const poolContract = getDelegateStakingPoolContract(client, poolAddress);

  return poolContract.read.owner();
}
